import { render, staticRenderFns } from "./addressBook.vue?vue&type=template&id=0fc7840e&scoped=true"
import script from "./addressBook.vue?vue&type=script&lang=js"
export * from "./addressBook.vue?vue&type=script&lang=js"
import style0 from "./addressBook.vue?vue&type=style&index=0&id=0fc7840e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc7840e",
  null
  
)

export default component.exports